export default "<p>global-settings works!</p>\n";